import React from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import AccountSellerListContainer from '../../../containers/account/seller/AccountSellerListContainer';
import { ACCOUNT_SELLER_PAGE_NAME } from '../../../constants/service/app/accountSellerConstants';

const AccountSellerList = () => {
  return (
    <PageTemplate pageName={ACCOUNT_SELLER_PAGE_NAME.SELLER_LIST}>
      <AccountSellerListContainer pageName={ACCOUNT_SELLER_PAGE_NAME.SELLER_LIST} />
    </PageTemplate>
  );
};

export default AccountSellerList;
